<template>
    <section id="questionTop" class="question container--narrow pdt-50 mgb-50">
        <div class="">
            <div v-if="groupQuestionCount === 1">
                <question-tag :avgSolveTime="question.avgSolveTime" :correctRate="question.avgSolveTime"
                    :level="paperLevel"></question-tag>
                <div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
                    <vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
                    <div v-else>
                        {{ question.contents.text }}
                    </div>
                </div>
                <div v-if="question.contents.image" class="mgt-16 independent-img-video-bd-radius">
                    <img :src="question.contents.image" alt="" />
                </div>

                <div class="mgt-24">
                    <div v-for="(choice, index) in question.choices" :key="index"
                        :class="selected[index] ? 'selected bg-quizBlack' : 'bg-quizGray'"
                        class="b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 box-54" tabindex="0" @click="setSelected(index)"
                        @keypress="setSelected(index)">
                        <div class="d-flex align-items-center">
                            <div :class="selected[index] ? 't-color-whiteHigh' : 't-color-quizBlack'
                                " class="q-count t-body1 l-spacing48 font-rn">
                                {{ index + 1 }}
                            </div>
                            <div :class="selected[index] ? 't-color-whiteHigh' : 't-color-quizBlack'
                                " class="t-body1 flex-grow-1 font-r">
                                <vue-mathjax v-if="question.useMathjax" :formula="choice.contents"
                                    class="font-r"></vue-mathjax>
                                <div v-else>
                                    {{ choice.contents }}
                                </div>
                            </div>
                        </div>
                        <div v-if="choice.image" class="mgt-24">
                            <img :src="choice.image" alt="" class="icon229" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="group mgb-30">
                <div v-if="index === 0" class="mgt-16 t-line-h-28 font-rn">
                    {{ groupQuestionTitle }}
                </div>

                <div class="mdc-card mdc-elevation--z3 pda-default mgt-16 bg-documentGray">
                    <question-tag
                        class="mgb-16"
                        :avgSolveTime="question.avgSolveTime"
                        :correctRate="question.avgSolveTime"
                        :level="paperLevel"
                    ></question-tag>
                    <div class="t-headline14">
                        <vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
                        <div v-else>
                            {{ question.contents.text }}
                        </div>
                    </div>
                    <div v-if="question.contents.image" class="mgt-16 independent-img-video-bd-radius">
                        <img :src="question.contents.image" alt="" />
                    </div>

                    <div class="question-choices mgt-16">
                        <div v-for="(choice, index) in question.choices" :key="index" :class="selected[index] ? 'selected bg-quizBlack' : 'bg-quizGray'"
                            class="b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 box-54" tabindex="0" @click="setSelected(index)" @keypress="setSelected(index)">
                            <div class="d-flex align-items-center">
                                <div 
                                    :class="selected[index] ? 't-color-whiteHigh' : 't-color-quizBlack'" 
                                    class="q-count t-body1 l-spacing48 font-rn">{{ index + 1 }}</div>
                                <div :class="selected[index] ? 't-color-whiteHigh' : 't-color-quizBlack'" class="t-body1 flex-grow-1 font-r">
                                    <vue-mathjax v-if="question.useMathjax" :formula="choice.contents" class="font-r"></vue-mathjax>
                                    <div v-else>
                                        {{ choice.contents }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="choice.image" class="mgt-11 mgb-10 mgl-16 mgr-16 independent-img-video-bd-radius">
                                <img :src="choice.image" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-1"></div>
            <question-tip v-if="question.tip" :tip="question.tip" />
        </div>
    </section>
</template>

<script>
/**
 * 단일답안 문항 컴포넌트(choice single type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import QuestionTag from "./QuestionTag.vue";
import QuestionTip from "./QuestionTip.vue";
import { questionMixin } from "@/mixins/question.js";

export default {
    props: [
        "question",
        "groupQuestionCount",
        "groupQuestionTitle",
        "currentQuestionCheckStatus",
        "setedAnswer",
        "paperLevel",
        "currentGroupIndex",
        "index"
    ],

    data() {
        return {
            selected: [],
            isSolve: false,
            formula: "$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.$$",
        };
    },

    components: {
        "question-tag": QuestionTag,
        "question-tip": QuestionTip,
    },

    mixins: [questionMixin],

    mounted() {
        console.log("TRUE FALSE : ", this.setedAnswer);
        this.selected = this.setedAnswer.selected;
        this.isSolve = this.setedAnswer.isSolve;
        this.solveTime = this.setedAnswer.solveTime || 0;
        this.startTimer();
        this.setAnswer();
    },

    updated() { },

    watch: {
        currentQuestionCheckStatus: function (value) {
            if (!value) {
                this.startTimer();
            } else {
                this.clearTimer();
            }
        },
    },

    methods: {
        //답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
        setSelected(selectedIndex) {
            console.log("@@@ SET SELECTED : TRUE FALSE : ", selectedIndex)
            if (this.selected[selectedIndex]) {
                this.selected = this.initAnswer();
                this.isSolve = false;
            } else {
                this.selected = this.initAnswer();
                for (var i = 0; i < this.selected.length; i++) {
                    if (i === selectedIndex) {
                        this.selected[i] = true;
                        this.isSolve = true;
                    }
                }
            }
            this.currentQuestionCheckTrueFalse();
            this.checkIsChecked();
            this.setAnswer();
        },

        // 답안설정(Answer setting)
        currentQuestionCheckTrueFalse() {
            this.$emit("checkCurrentQuestionStatus");
        },

        setAnswer() {
            let params = this.setParam();
            this.$emit("setAnswers", params);
        },

        checkIsChecked() {
            let params = this.setParam();
            this.$emit("checkIsCheckeds", params);
        },

        //답안 초기화(Initialize the answer)
        initAnswer() {
            return _(this.question.choices.length).times(() => {
                return false;
            });
        },

        // 파라미터 설정(set parameter)
        setParam() {
            let params = {
                questionId: this.question.id,
                text: "",
                selected: this.selected,
                texts: [],
                startDate: this.startDate,
                solveTime: this.solveTime,
                isSolve: this.isSolve,
                groupId: this.question.groupId,
            };

            return params;
        },
    },
};
</script>
